import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant13PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 998 1019",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M927.981 296.003C790.202 392.412 598.723 405.726 448.926 329.241C400.095 304.312 353.499 267.857 334.556 216.391C315.614 164.925 334.199 97.2412 384.861 76.2883C438.382 54.1293 501.687 93.8458 524.74 147.01C547.792 200.174 540.689 261.156 529.788 318.028C470.37 627.763 306.5 916.501 70.9707 1126.25",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant13PathwayIllustration as default };
